import {
  useQuery,
} from '@tanstack/react-query'
import { resourcefulScenarioRequest } from '../requests'

export function useForecastsQuery({
  scenarioID,
  initialData,
  queryKey
}) {

  const forecastRequests = resourcefulScenarioRequest(
    scenarioID, 'forecasts'
  )

  const forecastQuery = useQuery({
    queryFn: forecastRequests.create,
    initialData,
    refetchOnMount: false,
    queryKey,
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.forecast] })
      // queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.assetAllocation] })
    }
  })

  return {
    data: forecastQuery.data,
    status: forecastQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: forecastQuery.isFetching
  }
}
